import { render, staticRenderFns } from "./CountDiseaseByDiseaseTypeDiagram.vue?vue&type=template&id=59d530e0&scoped=true&"
import script from "./CountDiseaseByDiseaseTypeDiagram.vue?vue&type=script&lang=js&"
export * from "./CountDiseaseByDiseaseTypeDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d530e0",
  null
  
)

export default component.exports